import axios from 'axios'
const { VUE_APP_API_URL } = process.env

const sendPassword = async (payload) => {
  const result = { error: false }
  try {
    const apiURL = VUE_APP_API_URL
    const res = await axios
      .post(`${apiURL}/api/user/change?token=${payload.token}`, payload)
    if (res && res.data) {
      result.data = res.data
      return result
    }
  } catch (err) {
    result.error = true
    return result
  }
}

export {
  sendPassword
}
